export default __webpack_public_path__ + "static/media/Christmas bell wreath.ab282418.jpg";